export default __webpack_public_path__ + "static/media/title_ko_sp.ed0378a0.png";